import { Grid } from '@mui/joy'
// import { Flex } from '../../Flex'
import Section from '../../Section/Section'
// import { Text } from '../../Text'
import BlogBlock from './BlogBlock'
// import { Button } from '../../Button'

export default function Blogs({ data }) {
    return (
        <Section backgroundColor="#fff" pt={0}>
            <Grid container mt={12} spacing={10} mb={12}>
                {data &&
                    data.map((item) => (
                        <Grid xs={12} sm={6} md={4} key={item.postId}>
                            <BlogBlock
                                id={item.postId}
                                link={item.uri}
                                title={item.title}
                                excerpt={item.excerpt}
                                author={item.author?.node?.name}
                                src={item.featuredImage?.node?.sourceUrl}
                            />
                        </Grid>
                    ))}
            </Grid>
            {/* <Flex width="100%" justifyContent="space-btween">
                <Text>Showing 1-5 of 20</Text>
                <Box>
                    <Button>Show More</Button>
                </Box>
            </Flex> */}
        </Section>
    )
}
